/**
 * Mimu — scroll position indicator under the product media gallery.
 *
 * Mirrors the bar under the video testimonials: a thin track with a green thumb
 * whose width reflects how much of the gallery is visible and whose position
 * reflects how far along it is. Driven by the slideshow's own scroller, so it
 * tracks a swipe continuously rather than jumping slide to slide.
 *
 * The track hides itself whenever there is nothing to scroll — a single image, or
 * a presentation where the media is stacked rather than swiped — so it never shows
 * a full-width thumb that cannot move.
 */
(function () {
  var GALLERY = 'media-gallery';
  var SCROLLER = '[ref="scroller"]';
  var MIN_THUMB = 12; // percent, so it stays visible on very long galleries

  function wire(gallery) {
    var bar = gallery.querySelector('[data-mimu-gallery-bar]');
    var thumb = bar && bar.querySelector('[data-mimu-gallery-bar-thumb]');
    var scroller = gallery.querySelector(SCROLLER);
    if (!bar || !thumb || !scroller) return;

    var scheduled = false;

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;

      // Nothing to scroll: no honest position to show.
      if (max <= 1) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;

      var visible = scroller.clientWidth / scroller.scrollWidth;
      var width = Math.max(visible * 100, MIN_THUMB);
      thumb.style.width = width + '%';
      // Travel is the leftover track, so the thumb lands flush at either end.
      thumb.style.left = (scroller.scrollLeft / max) * (100 - width) + '%';
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        update();
      });
    }

    scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    // The gallery mounts and lays out late, and the launch template scrolls it to
    // a chosen slide on load, so re-measure for a moment after wiring up.
    schedule();
    [120, 400, 1000].forEach(function (delay) {
      setTimeout(schedule, delay);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(GALLERY), wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
